
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Onboarding from "./pages/Onboarding";
import Programs from "./pages/Programs";
import ProgramDetail from "./pages/ProgramDetail";
import Settings from "./pages/Settings";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import CreateProgram from "./pages/CreateProgram";
import NotFound from "./pages/NotFound";
import ProgramViewer from "./pages/ProgramViewer";
import { Toaster } from "./components/ui/toaster";
import ErrorBoundary from "./components/error/ErrorBoundary";
import "./App.css";

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/programs/:id" element={<ProgramDetail />} />
            <Route path="/create-program" element={<CreateProgram />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/:id" element={<ClientDetail />} />
            <Route path="/program-viewer/:id" element={<ProgramViewer />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster />
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
